import { defineStore } from 'pinia';

// Centraliza si los modales de login/registro están abiertos, para que
// cualquier componente pueda pedir login (no solo el desplegable del
// header) sin tener que pasar refs por props de un lado a otro.
// Ejemplo: un botón que requiere sesión llama a uiStore.openLogin()
// si authStore.isAuthenticated es false, en vez de ejecutar su acción.
export const useUiStore = defineStore('ui', {
  state: () => ({
    showLoginModal: false,
    showRegisterModal: false,
  }),
  actions: {
    openLogin() {
      this.showRegisterModal = false;
      this.showLoginModal = true;
    },
    openRegister() {
      this.showLoginModal = false;
      this.showRegisterModal = true;
    },
    closeAll() {
      this.showLoginModal = false;
      this.showRegisterModal = false;
    },
  },
});
